import Reeducation from "@/components/practitioner/programmation/Reeducation";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import BilanComponent from "@/components/practitioner/programmation/Bilan";
import { Button } from "@/components/ui/button";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Grid3X3 } from "lucide-react";

export const Programmation = () => {
  const navigate = useNavigate();
  const { patientId } = useParams();
  const sessionId = useParams().sessionId;
  const location = useLocation();
  
  let defaultValueTabs: "bilan" | "reeducation" = "reeducation";
  if (sessionId) {
    defaultValueTabs = location.state?.sessionType === "BILAN" ? "bilan" : "reeducation";
  }

  return (
    <div className="mt-11 mb-11">
      <Tabs defaultValue={defaultValueTabs}>
        <div className="w-full">
          <div className="w-1/6"></div>
          <TabsList className="w-2/4 text-center border-none">
            <TabsTrigger value="bilan" className="w-1/2">
              Bilan
            </TabsTrigger>
            <TabsTrigger value="reeducation" className="w-1/2">
              Rééducation
            </TabsTrigger>
          </TabsList>
          <Button
            type="button"
            onClick={() => navigate(`/praticien/${patientId}/parametragecv`)}
            className="w-1/6 ml-7"
          >
            <Grid3X3 className="h-4 w-4 mr-2" />
            Champ visuel
          </Button>
        </div>
        <TabsContent value="bilan" className="w-full flex justify-center">
          <BilanComponent />
        </TabsContent>
        <TabsContent value="reeducation" className="w-full flex justify-center">
          <Reeducation />
        </TabsContent>
      </Tabs>
    </div>
  );
};
